/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { RovoInsightsEntrypointProps } from './RovoInsights.entrypoint.types.tsx';

type RovoInsightsEntryPointComponent = EntryPointComponent<{}, {}, RovoInsightsEntrypointProps, {}>;

export const rovoInsightsEntryPoint: EntryPoint<RovoInsightsEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<RovoInsightsEntryPointComponent>(
			/* webpackChunkName: "async-itam-settings-rovo-insights" */ './RovoInsights.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
